import type { Theme } from "domains/theme/types";

export enum ThemeType {
  SET = "[Theme] - Set",
  SET_SUCCESS = "[Theme] - Update",
}

export type SetThemeAction = { theme: Theme; type: ThemeType.SET };
export type SetThemeSuccessAction = { theme: Theme; type: ThemeType.SET_SUCCESS };
